
    <div class="login-container">
        <div class="login-card">
            <h1 class="login-title">Enter Verification Code</h1>
            
            <div class="verification-info">
                <p class="verification-text">We've sent a 6-digit verification code to</p>
                <p class="phone-display">{{maskedPhone}}</p>
            </div>
            
            <input type="hidden" [(ngModel)]="loginData.username" />
            
            <div class="form-group">
                <label class="form-label">Verification Code</label>
                <input 
                    class="form-input code-input" 
                    type="tel" 
                    inputmode="numeric"
                    pattern="[0-9]*"
                    autocomplete="one-time-code"
                    placeholder="Enter 6-digit code"
                    maxlength="6"
                    (keyup.enter)="login()" 
                    [(ngModel)]="loginData.password"
                />
                <div class="form-hint">Check your SMS messages</div>
            </div>
            
            <button class="login-button" (click)="login()" type="submit">
                Verify & Login
            </button>
            
            <div class="action-links">
                <button class="resend-link" (click)="resendCode()" type="button">
                    Didn't receive code? Resend
                </button>
                <a href="/#/prelogin" class="back-link">Back to Login</a>
            </div>
            
            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>